import { isArray } from 'lodash';

/**
 * From:
 * [
 *  { id: 1, name: "abc.com" },
 *  { id: 2, name: "xyz.com" }
 * ]
 * To: "1,2"
 */
export const parseDomainObjToString = (listDomain = []) => {
  if (isArray(listDomain)) {
    return listDomain.map((el) => `${el.id}`).join(',');
  }
  return '';
};

export const parseDomainStringToObj = (domain = '', domains = []) => {
  if (domain && isArray(domains)) {
    return domain.split(',').map((el, idx) => ({
      id: el,
      label: domains[idx],
      value: el,
    }));
  }
  return [];
};
